import { render, staticRenderFns } from "./insureList.vue?vue&type=template&id=5d1f748a&scoped=true"
import script from "./insureList.vue?vue&type=script&lang=js"
export * from "./insureList.vue?vue&type=script&lang=js"
import style0 from "./insureList.vue?vue&type=style&index=0&id=5d1f748a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1f748a",
  null
  
)

export default component.exports